import React from "react";
import ReactDOM from "react-dom";
import 'antd/dist/antd.css';
import "./index.scss";
import App from "./App";
import {store,persistor} from "./redux/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import history from "./assets/history";
import { BrowserRouter as Router } from "react-router-dom";
import Login from "./components/Login";
import { PersistGate } from 'redux-persist/integration/react';
import UserService from "./redux/services/UserService";
import '../node_modules/font-awesome/css/font-awesome.min.css'; 

const renderApp =() => {
   ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate  persistor={persistor}>
      <Router history={history}>
        
        {
      <App/>
        }
      </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
}
UserService.initKeycloak(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();